import request from '@/utils/request'

// 查询质量官管理列表
export function listZlg(query) {
  return request({
    url: '/web/zlts/zlg/list',
    method: 'get',
    params: query
  })
}

// 查询质量官管理详细
export function getZlg(recid) {
  return request({
    url: '/web/zlts/zlg/' + recid,
    method: 'get'
  })
}

// 新增质量官管理
export function addZlg(data) {
  return request({
    url: '/web/zlts/zlg',
    method: 'post',
    data: data
  })
}

// 修改质量官管理
export function updateZlg(data) {
  return request({
    url: '/web/zlts/zlg/edit',

    method: 'post',
    data: data
  })
}

// 删除质量官管理
export function delZlg(recid) {
  return request({
    url: '/web/zlts/zlg/remove/' + recid,

    method: 'post',
  })
}